import {
  ConversationBalanceMetricName,
  ConversationBalanceMetricUnit,
} from 'components/AiAnalytics/shared/aiWidgetResponse.types';

const formatNumber = (value: number): string =>
  Number.isInteger(value) ? value.toString() : value.toFixed(1).replace(/\.0$/, '');

const formatDuration = (seconds: number): string => {
  if (seconds < 60) return `${formatNumber(seconds)}s`;

  const wholeMinutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return remainingSeconds === 0
    ? `${wholeMinutes}m`
    : `${wholeMinutes}m ${formatNumber(remainingSeconds)}s`;
};

export const formatConversationBalanceRawValue = (
  value: number,
  unit: ConversationBalanceMetricUnit,
  metric: ConversationBalanceMetricName
): string => {
  if (unit === 'seconds') {
    return metric === 'handle_time' ? formatDuration(value) : `${formatNumber(value)}s`;
  }
  if (unit === 'characters') return `${formatNumber(value)} chars`;
  return `${formatNumber(value)} msgs`;
};
